import { InvoiceLine, StructureTypeDescriptions } from '@apply/api/src/api/PaymentApi';
import { Fragment } from 'react/jsx-runtime';

interface ValuationRowParameters {
    index: number;
    invoiceLine: InvoiceLine;
}

export const ValuationRow: React.FC<ValuationRowParameters> = ({ index, invoiceLine }) => {
    return (
        <Fragment key={index}>
            <div className='invoice-type'>
                ({invoiceLine.index}) {invoiceLine.address1}
                {invoiceLine.address2?.length ? `, ${invoiceLine.address2}` : ''}{' '}
                {StructureTypeDescriptions[invoiceLine.structureType]}
            </div>
            <div className='invoice-cost' />
            <div className='invoice-subtotal'>${Number(invoiceLine.cost)}</div>
            <div className='invoice-notes'>{invoiceLine.cost == 0 ? '(pay at closing)' : ''}</div>
        </Fragment>
    );
};
